import React, { useEffect, useState } from 'react';
import AnalyticsConsent from '../components/AnalyticsConsent';
import ForgotPassword from '../components/ForgotPassword';
import api from '../utils/api';
import { messageForReason, takeSessionEndReason } from '../utils/session';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import Component
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'; // Import Icons
import '../styles/Auth.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    
    const [showPassword, setShowPassword] = useState(false);
    const [showForgot, setShowForgot] = useState(false);
    // Why they were signed out, if they were (utils/session.js). Read here, cleared once shown.
    const [notice] = useState(() => {
        try { return messageForReason(sessionStorage.getItem('session_end_reason')); } catch { return null; }
    });
    useEffect(() => { takeSessionEndReason(); }, []);
    
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post('/auth/login', { 
                email: email.trim(), 
                password 
            });
            
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('user', JSON.stringify(res.data.user));

            Swal.fire({
                icon: 'success',
                title: 'Welcome Back!',
                text: `Logged in as ${res.data.user.name}`,
                timer: 1500,
                showConfirmButton: false,
                iconColor: '#215D7B'
            });

            setTimeout(() => {
                navigate('/dashboard');
                window.location.reload();
            }, 1500);

        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Login Failed',
                text: err.response?.data?.message || 'Invalid Credentials',
                confirmButtonColor: '#215D7B'
            });
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <img src="/GTS.png" alt="GTS Logo" style={{ height: '50px' }} />
                </div>

                {showForgot ? (
                    <ForgotPassword
                        initialEmail={email}
                        onBack={() => setShowForgot(false)}
                        onDone={(resetEmail) => { setEmail(resetEmail); setPassword(''); setShowForgot(false); }}
                    />
                ) : (
                <>
                <h2>Portal Login</h2>
                <p className="auth-subtitle">Welcome back! Please enter your details.</p>
                {notice && <div className="auth-notice" role="status">{notice}</div>}
                
                <form onSubmit={handleLogin}>
                    <div className="form-group">
                        <label>Email Address</label>
                        <input 
                            type="email" 
                            className="auth-input"
                            placeholder="e.g. employee@gts.ai"
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)} 
                            required 
                        />
                    </div>

                    <div className="form-group">
                        <label>Password</label>
                        <div style={{ position: 'relative' }}>
                            <input 
                                type={showPassword ? "text" : "password"} 
                                className="auth-input"
                                placeholder="••••••••"
                                value={password} 
                                onChange={(e) => setPassword(e.target.value)} 
                                required 
                                style={{ paddingRight: '40px' }} 
                            />
                            
                            {/* Eye Icon */}
                            <span 
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: 'absolute',
                                    right: '15px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    color: 'light-dark(#666, var(--theme-body, #b9bec6))'
                                }}
                            >
                                <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                            </span>
                        </div>
                    </div>

                    <button type="submit" className="auth-btn">Sign In</button>

                    <button
                        type="button"
                        className="forgot-link"
                        onClick={() => setShowForgot(true)}
                    >
                        Forgot password?
                    </button>
                </form>
                </>
                )}
            </div>
            <AnalyticsConsent />
        </div>
    );
};

export default Login;
